import {ModuleWithProviders, NgModule} from '@angular/core';
import {XlsxDirective} from './xlsx.directive';
import {DA_XLSX_CONFIG, XlsxConfig} from './interface';
import {XlsxService} from './xlsx.service';

const EXPORTS = [XlsxDirective];
@NgModule({
  imports: [],
  declarations: [...EXPORTS],
  exports: [...EXPORTS]
})
export class JdXlsxModule {
  static forRoot(config?: XlsxConfig): ModuleWithProviders {
    return {
      ngModule: JdXlsxModule,
      providers: [XlsxService, { provide: DA_XLSX_CONFIG, useValue: config }]
    };
  }
}
